"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var webAApi_1 = require("../../../../api/webAApi");
var UsrPermissionDocsCtl = /** @class */ (function (_super) {
    __extends(UsrPermissionDocsCtl, _super);
    function UsrPermissionDocsCtl(errDialog, state) {
        var _this = _super.call(this, true) || this;
        _this.dk_doc_identity = UIUtils_1.UIUtils.IProp2Str(function (o) { o.doc_identity; });
        _this.dk_doc_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.doc_title; });
        _this.dk_doc_category = UIUtils_1.UIUtils.IProp2Str(function (o) { o.doc_category; });
        _this.dk_doc_icon = UIUtils_1.UIUtils.IProp2Str(function (o) { o.doc_icon; });
        _this.dk_doc_icon_kind = UIUtils_1.UIUtils.IProp2Str(function (o) { o.doc_icon_kind; });
        _this.dk_doc_permission_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.doc_permission_code; });
        _this.dk_doc_permission_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.doc_permission_title; });
        _this.dk_doc_view_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.doc_view_code; });
        _this.dk_doc_view_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.doc_view_title; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        _this._state = state;
        return _this;
    }
    UsrPermissionDocsCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            doc_category_filter: [],
            total: 0
        };
    };
    UsrPermissionDocsCtl.prototype.getByDocIdentity = function (identity) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].doc_identity === identity) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    UsrPermissionDocsCtl.prototype.LoadData = function (usrAdminPermissionId, onDone) {
        var _this = this;
        webAApi_1.ListDocumentsByPermissionIdGet.exec({
            usr_admin_permission_id: usrAdminPermissionId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.doc_category_filter = [];
            var doc_category_filter_map = new Map();
            for (var i = 0; i < resp.list.length; i++) {
                if (!doc_category_filter_map.get(resp.list[i].doc_category)) {
                    _this.DATA.doc_category_filter.push({ text: resp.list[i].doc_category, value: resp.list[i].doc_category });
                    doc_category_filter_map.set(resp.list[i].doc_category, resp.list[i].doc_category);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    doc_identity: resp.list[i].doc_identity,
                    doc_title: resp.list[i].doc_title,
                    doc_category: resp.list[i].doc_category,
                    doc_icon: resp.list[i].doc_icon,
                    doc_icon_kind: resp.list[i].doc_icon_kind,
                    doc_permission_code: resp.list[i].doc_permission_code,
                    doc_permission_title: resp.list[i].doc_permission_title,
                    doc_view_code: resp.list[i].doc_view_code,
                    doc_view_title: resp.list[i].doc_view_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    UsrPermissionDocsCtl.prototype.doSetAccessDocumentPermission = function (param, onDone) {
        var _this = this;
        webAApi_1.DoSetAccessPermissionOnDocControl.exec({
            data: {
                document_identity: param.doc_identity,
                usr_admin_permission_id: param.admin_permission_id,
                access_type_code: param.access_type_code
            }
        }, function (resp) {
            var _tmp = _this.getByDocIdentity(param.doc_identity);
            if (_tmp) {
                _tmp.doc_permission_code = param.admin_permission_id;
                _tmp.doc_permission_title = resp.access_type_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
            }
            else {
                throw "not found in set permission!";
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    UsrPermissionDocsCtl.prototype.doSetViewDocumentPermission = function (param, onDone) {
        var _this = this;
        webAApi_1.DoSetViewPermissionOnDocControl.exec({
            data: {
                document_identity: param.doc_identity,
                usr_admin_permission_id: param.admin_permission_id,
                view_type_code: param.view_type_code
            }
        }, function (resp) {
            var _tmp = _this.getByDocIdentity(param.doc_identity);
            if (_tmp) {
                _tmp.doc_view_code = param.admin_permission_id;
                _tmp.doc_view_title = resp.view_type_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
            }
            else {
                throw "not found in set permission!";
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return UsrPermissionDocsCtl;
}(BaseController_1.BaseController));
exports.UsrPermissionDocsCtl = UsrPermissionDocsCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_permissions_list/ctl/UsrPermissionDocsCtl.ts
// module id = 925
// module chunks = 0